import axios from 'axios'

/**
 * @desc Fetch All Order Queries for Supplier
 * @desc API fetchQueriesForSupplierAndStatus in BFF
 * @param {Integer} supplierId - supplierId
 * @param {Array} status - 'APPROVED' , 'OUTSTANDING', 'REJECTED'
 * @param {String} query - Includes several search parameters
 */
export const fetchOrderQueries = (
  supplierId,
  page,
  size,
  status = [],
  query
) => {
  let baseQuery = `supplierId=${supplierId}&page=${page}&size=${size}&status=${status}`
  if (query) baseQuery += `&${query}`

  return axios
    .get(`/authenticated/supplier-order-query?${baseQuery}`)
    .then((res) => res.data)
}

/**
 * @desc Fetch Order Query Details
 * @desc API fetchQuery in BFF
 */
export const fetchOrderQuery = (id) =>
  axios.get(`/authenticated/supplier-order-query/${id}`).then((res) => res.data)

/**
 * @desc Finalise Order Query
 * @desc API finaliseQuery in BFF
 */
export const finaliseOrderQuery = (id, request) =>
  axios
    .put(`/authenticated/supplier-order-query/${id}/finalise`, request)
    .then((res) => res.data)

/**
 * @desc Approve an individual Order Query Issue
 * @desc API approveQueryIssue in BFF
 */
export const approveOrderQueryIssue = (id, issueId) =>
  axios
    .put(`/authenticated/supplier-order-query/${id}/issues/${issueId}/approve`)
    .then((res) => res.data)

/**
 * @desc Reject an individual Order Query Issue
 * @desc API rejectQueryIssue in BFF
 */
export const rejectOrderQueryIssue = (id, issueId) =>
  axios
    .put(`/authenticated/supplier-order-query/${id}/issues/${issueId}/reject`)
    .then((res) => res.data)

/**
 * @desc Fetch Order Query PDF
 * @desc getCreditNotePdfUrl in BFF
 */
export const fetchOrderQueryPdfUrl = (id) =>
  axios
    .get(`/authenticated/supplier-order-query/${id}/credit-note`)
    .then((res) => res.data)

export const fetchOrderQueryInvoicePdfUrl = (id) =>
  axios
    .get(`/authenticated/supplier-order-query/${id}/pdf/invoice/url`)
    .then((res) => res.data)

/**
 * @desc Fetches Order Queries Statistics
 * @desc API getQueryStatusStatistics in BFF
 */
export const fetchQueryStatusStatistics = () =>
  axios
    .get(`/authenticated/supplier-order-query/statistics`)
    .then((res) => res.data)
